import LegalLayout from "@/pages/LegalLayout";

export default function GizlilikPolitikasi() {
  return (
    <LegalLayout title="Gizlilik Politikası">
      <p className="text-sm text-zinc-500">
        Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
      </p>

      <h2>1. Amaç ve Kapsam</h2>
      <p>
        Bu Gizlilik Politikası, Kolay Arşivim uygulaması ("Uygulama") tarafından
        toplanan kişisel verilerin nasıl işlendiğini, saklandığını ve korunduğunu
        açıklar. Uygulamayı kullanmakla bu politikayı kabul etmiş sayılırsınız.
      </p>

      <h2>2. Toplanan Bilgiler</h2>
      <ul>
        <li>Kayıt sırasında sağladığınız <strong>ad, e-posta ve şifre</strong>
          (şifre bcrypt algoritmasıyla geri döndürülemez şekilde hash'lenerek
          saklanır).</li>
        <li>Uygulama içinde oluşturduğunuz <strong>ekspertiz kayıtları</strong>.</li>
        <li>Oturum çerezi (HttpOnly, Secure, SameSite=Lax) — yalnızca kimlik
          doğrulama için.</li>
      </ul>

      <h2>3. Verilerin Kullanımı</h2>
      <p>
        Verilerinizi yalnızca (i) hizmeti sağlamak, (ii) hesap güvenliğinizi
        korumak ve (iii) yasal yükümlülükleri yerine getirmek için kullanırız.
        Pazarlama amaçlı üçüncü taraflarla paylaşmayız.
      </p>

      <h2>4. Güvenlik Önlemleri</h2>
      <ul>
        <li>Tüm veri iletimi HTTPS/TLS üzerinden yapılır.</li>
        <li>Şifreler bcrypt ile hash'lenir; ham şifre asla saklanmaz.</li>
        <li>Oturum tokenleri HttpOnly + Secure + SameSite=Lax çerezlerle taşınır.</li>
        <li>Brute-force koruması: 10 dakikada 8 başarısız denemeden sonra IP
          engellenir.</li>
        <li>Güvenlik başlıkları: HSTS, X-Content-Type-Options, X-Frame-Options,
          Referrer-Policy uygulanır.</li>
        <li>NoSQL enjeksiyon koruması: kullanıcı girdileri regex-escape edilir.</li>
        <li>XSS koruması: React otomatik JSX escape'i + JSON API yanıtları.</li>
        <li>CSRF koruması: SameSite=Lax çerez politikası.</li>
        <li>Kullanıcı izolasyonu: her ekspertiz kaydı yalnızca sahibi tarafından
          erişilebilir.</li>
      </ul>

      <h2>5. Çerezler</h2>
      <p>
        Yalnızca zorunlu (kimlik doğrulama) çerezler kullanılır. Analitik veya
        pazarlama çerezi kullanılmaz. Detay için Çerez Politikamıza bakın.
      </p>

      <h2>6. Verilerinize Erişim ve Silme</h2>
      <p>
        Uygulama içindeki "Ayarlar → Verilerimi İndir" ile tüm verinizi JSON
        olarak indirebilir; "Hesabımı Sil" ile hesabınızı ve tüm ekspertiz
        kayıtlarınızı kalıcı olarak silebilirsiniz. Silme işlemi geri alınamaz.
      </p>

      <h2>7. Değişiklikler</h2>
      <p>
        Bu politikada değişiklik yapıldığında Uygulama üzerinde duyurulur.
        Devam eden kullanım, güncel politikanın kabulü anlamına gelir.
      </p>
    </LegalLayout>
  );
}
